import { ActionItem, OwnerCollaboratorEmployee } from 'models/actionItem';

import { AGENDA_TAG_LABEL_TYPES, TASK_EMPLOYEE_TYPES, TASK_TYPES } from 'constants/ProjectConstants';
import { generateKey } from 'constants/helper';

export const ACTION_ITEMS_LIST_REDUCER_ADD = 'ACTION_ITEMS_LIST_REDUCER_ADD';
export const ACTION_ITEMS_LIST_REDUCER_UPDATE = 'ACTION_ITEMS_LIST_REDUCER_UPDATE';
export const ACTION_ITEMS_LIST_REDUCER_REMOVE = 'ACTION_ITEMS_LIST_REDUCER_REMOVE';
export const ACTION_ITEMS_LIST_REDUCER_REMOVE_ALL = 'ACTION_ITEMS_LIST_REDUCER_REMOVE_ALL';

export const ACTION_ITEM_UPDATE = 'ACTION_ITEM_UPDATE';
export const ACTION_ITEM_ENABLE_EDITING = 'ACTION_ITEM_ENABLE_EDITING';
export const ACTION_ITEM_DISABLE_EDITING = 'ACTION_ITEM_DISABLE_EDITING';

function addActionItemAction(actionItem, addType = 'prepend') {
  return { type: ACTION_ITEMS_LIST_REDUCER_ADD, actionItems: [actionItem], addType };
}

export function addActionItemsAction(actionItems, addType = 'append') {
  return { type: ACTION_ITEMS_LIST_REDUCER_ADD, actionItems, addType };
}

export function addNewActionItemAction(loggedInEmployee, { levelUpCompetencyId, agendaId }, addType) {
  const { id, designation, displayName, profilePhotoSrc: profilePhoto } = loggedInEmployee;

  let label = null;

  if (agendaId) {
    label = {
      uuid: agendaId,
      labelType: AGENDA_TAG_LABEL_TYPES.LABEL_AGENDA.value,
    };
  } else if (levelUpCompetencyId) {
    label = {
      uuid: levelUpCompetencyId,
      labelType: AGENDA_TAG_LABEL_TYPES.LABEL_LEVELUP.value,
    };
  }

  const newActionItem = new ActionItem({
    uuid: null,
    text: '',
    status: TASK_TYPES.active,
    uiKey: generateKey(7),
    toIds: [
      new OwnerCollaboratorEmployee({
        id,
        displayName,
        designation,
        profilePhoto,
        ownerType: TASK_EMPLOYEE_TYPES.owner,
      }),
    ],
    label,
    dueTime: {},
    teams: null,
  });

  newActionItem.isEditing = true;
  return addActionItemAction(newActionItem, addType);
}

export function removeActionItemAction(actionItemId, uiKey) {
  return { type: ACTION_ITEMS_LIST_REDUCER_REMOVE, data: { actionItemId, uiKey } };
}

export function removeAllActionItemsAction() {
  return { type: ACTION_ITEMS_LIST_REDUCER_REMOVE_ALL, data: {} };
}

export function updateActionItemAction(actionItem) {
  return {
    type: ACTION_ITEM_UPDATE,
    data: { actionItemId: actionItem.uuid, uiKey: actionItem.uiKey, actionItem },
  };
}

export function enableActionItemEditingAction({ actionItemId, uiKey }) {
  return { type: ACTION_ITEM_ENABLE_EDITING, data: { actionItemId, uiKey } };
}

// actionItem is optional here
export function disableActionItemEditingAction({ actionItemId, uiKey, actionItem }) {
  return { type: ACTION_ITEM_DISABLE_EDITING, data: { actionItemId, uiKey, actionItem } };
}
